// src/components/auth/verification/Pending.tsx
import React from "react";
import { Row, Typography } from "antd";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";

const { Title, Text } = Typography;

const CenteredTitle = styled(Title)`
  text-align: center;
  color: #3552fc;
`;

const PendingContainer = styled.div`
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`;

const Pending: React.FC = () => (
  <PendingContainer>
    <Helmet>
      <title>Verification Pending - OLS</title>
      <meta name="description" content="Your verification is pending with One Light System OLS." />
    </Helmet>
    <CenteredTitle level={2}>Pending Verification</CenteredTitle>
    <Text>Your account is under review. We'll notify you once verification is complete.</Text>
  </PendingContainer>
);

export default Pending;